import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import actions from 'store/actions';
import getters from 'store/getters';
import mutations from 'store/mutations';
import fatal from 'store/modules/fatal';
import accordion from 'store/modules/accordion';
import menu from 'store/modules/menu';
import timeline from 'store/modules/timeline';
import http from 'store/modules/http';
import resources from 'store/modules/resources';
import modal from 'store/modules/modal';
import documents from 'store/modules/documents';
import dropdown from 'store/modules/dropdown';
import lost from 'store/modules/lost';
import mini from 'store/modules/mini';
import claim from 'store/modules/claim';
import personal from 'store/modules/personal';
import dashboards from 'store/modules/dashboards';
import user from 'store/modules/user';
import psla from 'store/modules/psla';
import reserves from 'store/modules/reserves';
import support from 'store/modules/support';
import discountRateComparison from 'store/modules/discountRateComparison';
import windowWidth from 'store/modules/windowWidth';
import headerWidth from 'store/modules/headerWidth';

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: false,
    actions,
    getters,
    mutations,
    modules: {
        documents,
        fatal,
        accordion,
        menu,
        timeline,
        http,
        resources,
        modal,
        dropdown,
        lost,
        mini,
        claim,
        personal,
        dashboards,
        user,
        psla,
        reserves,
        support,
        discountRateComparison,
        windowWidth,
        headerWidth
    },
    plugins: [createPersistedState({
        paths: ['menu', 'user']
    })],
});

export default store;

if (module.hot) {
    // accept actions and mutations as hot modules
    module.hot.accept([
        'store/mutations',
        './modules/fatal',
        './modules/lost',
        './modules/mini',
        './modules/accordion',
        './modules/menu',
        './modules/timeline',
        './modules/http',
        './modules/claim',
        './modules/personal',
        './modules/dashboards',
        './modules/user',
        './modules/reserves',
        './modules/support',
        './modules/discountRateComparison',
    ], () => {
        // require the updated modules
        // have to add .default here due to babel 6 module output
        const newMutations = require('./mutations').default;
        const newFatal = require('./modules/fatal/index').default;
        const newMini = require('./modules/mini/index').default;
        const newLost = require('./modules/lost/index').default;
        const newAccordion = require('./modules/accordion').default;
        const newMenu = require('./modules/menu').default;
        const newTimeline = require('./modules/timeline').default;
        const newHttp = require('./modules/http').default;
        const newClaim = require('./modules/claim').default;
        const newPersonal = require('./modules/personal').default;
        const newDashboards = require('./modules/dashboards').default;
        const newUser = require('./modules/user').default;
        const newPsla = require('./modules/psla').default;
        const newReserve = require('./modules/reserves').default;
        const newSupport = require('./modules/support').default;
        const newDiscountRateComparison = require('./modules/discountRateComparison').default;
        // swap in the new actions and mutations
        store.hotUpdate({
            mutations: newMutations,
            modules: {
                fatal: newFatal,
                accordion: newAccordion,
                menu: newMenu,
                timeline: newTimeline,
                http: newHttp,
                lost: newLost,
                mini: newMini,
                claim: newClaim,
                personal: newPersonal,
                dashboards: newDashboards,
                user: newUser,
                psla: newPsla,
                reserves: newReserve,
                support: newSupport,
                discountRateComparison: newDiscountRateComparison,
            },
        });
    });
}



// WEBPACK FOOTER //
// ./src/store/index.js